<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),

    ...mapState('auth', ['showPrivacy']),

    showModal: {
      get() {
        return this.show || this.showPrivacy
      },
      set() {},
    },
  },

  methods: {
    ...mapActions('auth', [
      'logout',
      'acceptPrivacyPolicy',
      'updateUserAgreementsModals',
    ]),

    closeModal() {
      this.updateUserAgreementsModals({ showPrivacy: false })

      if (this.currentUser && this.currentUser.privacy_accepted === false) {
        this.logout()
      }
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Privacy Policy"
      hide-footer
      header-class="col12 bg-primary text-white text-center closeButton"
      title-class="w-100"
      size="xl"
      modal-class="mt-5 pt-5"
      @close="closeModal"
      @hidden="closeModal"
    >
      <div class="px-5 py-2">
        <b-row>
          <b-col cols="12" class="info pb-4 text-left">
            <p>
              You have been provided access to this system by your organisation.
              If you have any queries or questions regarding the use of
              Passenger Assist data, please contact your organisation’s Data
              Protection Officer (DPO).
            </p>
          </b-col>
        </b-row>

        <b-row v-if="currentUser.privacy_accepted === false">
          <b-col cols="12" class="d-flex justify-content-center">
            <b-button block class="ok-button reject-button" @click="closeModal">
              Reject
            </b-button>
            <b-button
              block
              variant="primary"
              class="ok-button"
              @click="acceptPrivacyPolicy"
            >
              Accept
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import '@variables';

.modal-dialog {
  margin-bottom: 100px;
}

.info {
  font-size: 16px;
}

.reject-button {
  margin-top: 8px;
  margin-right: 43px;
  background-color: $gray-secondary !important;
  border-color: $gray-secondary !important;
}

.ok-button {
  width: 130px !important;
  font-weight: bold;
}
</style>
